<template>
  <Button variant="outline" size="grow" :label="label" :padding="padding">
    <template #start>
      <FlipBackward class="w-5 h-5" />
    </template>
  </Button>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Button } from "@/Components/Button";
import { FlipBackward } from "@/Icons";

const { t } = useI18n();

const props = defineProps({
  padding: { type: String, default: "default" },
  showText: { type: Boolean, default: true },
});

const label = computed(() =>
  props.showText ? t("components.buttons.back") : ""
);
</script>
